import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/skin-smoother"
    exact
    path="/consumer/features/skin-smoother"
    component={AsyncPage}
  />,
];
